import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

export type RdButtonType = 'primary' | 'secondary';

const variantClasses: Record<RdButtonType, string> = {
  primary:
    'bg-[#007dbc] hover:bg-[#005f92] active:bg-[#005f92] text-white border-none',
  secondary:
    'bg-white text-[#007dbc] border border-solid border-[#002f6b30] shadow-[0_1px_4px_-0px_rgba(0,47,107,0.15)] hover:shadow-[0_2px_5px_-0px_rgba(0,47,107,0.15)]',
};
@Component({
  selector: 'button[bnz-button], a[bnz-button]',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BnzButtonComponent {
  @HostBinding('class') get rdButtonClass(): string {
    const classes = [
      'disabled:opacity-30 disabled:cursor-not-allowed box-border font-bold',
      'focus:outline outline-[3px] outline-[#007dbc]/[.65]',
      'h-10 px-4 rounded-[3px] cursor-pointer text-base',
      variantClasses[this.rdType],
    ];
    return classes.filter(Boolean).join(' ');
  }

  @Input() rdType: RdButtonType = 'secondary';

  constructor() {}
}
